var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 1.16797V4.5013M5.16667 1.16797V4.5013M1 7.83464H16M2.66667 2.83464H14.3333C15.2538 2.83464 16 3.58083 16 4.5013V16.168C16 17.0884 15.2538 17.8346 14.3333 17.8346H2.66667C1.74619 17.8346 1 17.0884 1 16.168V4.5013C1 3.58083 1.74619 2.83464 2.66667 2.83464Z",
    stroke: "#646D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f16ae13aa700a6d98e5b0aeb8cf472d0.svg";
export { ForwardRef as ReactComponent };